export async function openPaymentUrl(paymentUrl, {
    getWebApp = () => window.Telegram?.WebApp,
    navigate = url => window.location.assign(url),
} = {}) {
    let safeUrl;
    try {
        safeUrl = new URL(paymentUrl);
        if (!['https:', 'http:'].includes(safeUrl.protocol)) {
            throw new Error('Unsupported payment URL protocol');
        }
    } catch {
        throw new Error('Платёжная система вернула некорректную ссылку');
    }

    // The hook's isTelegram flag can be stale after Telegram restores a WebView.
    // Authentication has already happened on the backend before we get this URL.
    // Read the current bridge directly and never make payment navigation depend
    // on mutable initData or an old client-side launch flag.
    const webApp = getWebApp();
    if (typeof webApp?.openLink === 'function') {
        try {
            await Promise.resolve(webApp.openLink(safeUrl.href));
            return 'telegram';
        } catch (error) {
            console.warn('Telegram openLink failed; navigating directly:', error);
        }
    }

    // A full navigation works in restored WebViews and is not subject to popup
    // blocking after the asynchronous invoice request has completed.
    navigate(safeUrl.href);
    return 'navigation';
}
